import React, { useState } from 'react';
import api from '../utils/api';

function CreateInvitation({ onInvitationCreated }) {
  const [fullName, setFullName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', isError: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ text: '', isError: false });

    try {
      const response = await api.post('/invitation/create', {
        name: fullName
      });

      setMessage({ 
        text: `Invitation created successfully! Secret Code: ${response.data.secretCode}`, 
        isError: false 
      });
      setFullName('');
      
      onInvitationCreated();
      
    } catch (error) {
      setMessage({ 
        text: 'Error creating invitation. Please try again.', 
        isError: true 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Create New Invitation</h3>
      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label htmlFor="fullName" className="block text-xs font-medium text-gray-700 mb-1">
            Full Name
          </label>
          <input
            type="text"
            id="fullName"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-primary-200 focus:border-primary-500 outline-none"
            placeholder="Enter guest's full name"
            required
          />
        </div>
        <button
          type="submit"
          disabled={isLoading}
          className={`w-full px-3 py-2 text-sm text-white rounded-md transition-colors ${
            isLoading 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-primary-600 hover:bg-primary-700'
          }`}
        >
          {isLoading ? 'Creating...' : 'Create Invitation'}
        </button>
      </form>
      {message.text && (
        <div className={`mt-3 p-2 text-sm rounded-md ${
          message.isError 
            ? 'bg-red-50 text-red-700' 
            : 'bg-green-50 text-green-700'
        }`}>
          {message.text}
        </div>
      )}
    </div>
  );
}

export default CreateInvitation; 